// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

import { getFirestore, collection, onSnapshot, setDoc, addDoc, doc, where, deleteDoc, query } from "firebase/firestore";

import { getAuth, signInWithEmailAndPassword } from "firebase/auth";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCDUQsPfpcG-k7Le4042dAy-DPlSDYq-jc",
  authDomain: "packapp-qc.firebaseapp.com",
  projectId: "packapp-qc",
  storageBucket: "packapp-qc.appspot.com",
  messagingSenderId: "828169002218",
  appId: "1:828169002218:web:b284dc73fc882367830b93",
  measurementId: "G-D6X2D99JX7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth();
// const analytics = getAnalytics(app);

export { db, doc, collection, setDoc, deleteDoc, query, onSnapshot, addDoc, where, auth, signInWithEmailAndPassword };
